import _ from "lodash";
export const getJoinedArray = array => {
  return Array.isArray(array) ? _.join(array, ", ") : "";
};
